import { createRoot } from "react-dom/client";
import { ChatReader } from "./reader";
import { appWithErrorHandlerOf } from "reader-common"

const domContainer = document.getElementById("kn-reader-container");
const rdrRoot = createRoot(domContainer);

const Application = appWithErrorHandlerOf(ChatReader);

rdrRoot.render( <Application /> );